import React from 'react'
import UserLayout from '../../layouts/UserLayout'
import { Box, Backdrop, CircularProgress, Typography, useMediaQuery, Card } from '@mui/material'
import { getFromStorage } from '../../utils/storage'
import { useStatisticsSM } from '../../hooks/useStatisticsSM'
import StatisticsFilters from '../../components/statistics/StatisticsFilters'
import StatisticsOrderDetail from '../../components/statistics/StatisticsOrderDetail'
import { mainGreen } from '../../utils/color'
import StatisticUpdateHistoryModal from '../../components/StatisticUpdateHistoryModal'

export default function StatisticsSMToday() {
	const token = getFromStorage('current-user')?.accessToken
	const mediaMd = useMediaQuery('(min-width:768px)')

	const {
		statistics,
		users,
		loadingStatistics,
		timePick,
		shift,
		userFilter,
		orderFilter,
		currentImage,
		isViewerOpen,
		setTime,
		setShift,
		handleChangeUser,
		handleChangeOrder,
		openImageViewer,
		closeImageViewer,
		setShowBackdrop,
		updateHistory,
		setUpdateHistory,
		setOrderDetail,
		handleViewDetail,
	} = useStatisticsSM(token)

	const handleViewHistory = (order) => {
		setUpdateHistory(order.updatedOrderDetail)
		setOrderDetail(order)
		setShowBackdrop(true)
	}

	const renderLoading = () => (
		<Box sx={styles.loadingContainer}>
			<CircularProgress sx={{ color: mainGreen }} />
		</Box>
	)

	const renderImageViewer = () => (
		<Backdrop sx={styles.backdrop(mediaMd)} open={isViewerOpen} onClick={closeImageViewer}>
			<img
				loading='lazy'
				src={currentImage}
				alt='attach'
				style={styles.viewerImage}
				onClick={(e) => e.stopPropagation()}
			/>
		</Backdrop>
	)

	const renderNoData = () => (
		<Box sx={styles.noDataContainer}>
			<Typography sx={{ textAlign: 'center' }}>Chưa có dữ liệu</Typography>
		</Box>
	)

	const renderOrderList = () => (
		<Box sx={styles.orderListContainer(mediaMd)}>
			{statistics?.detail?.map((order, index) => (
				<StatisticsOrderDetail
					key={index}
					order={order}
					onViewDetail={handleViewDetail}
					onViewHistory={handleViewHistory}
					onImageClick={openImageViewer}
					token={token}
				/>
			))}
		</Box>
	)

	return (
		<UserLayout>
			{loadingStatistics ? (
				renderLoading()
			) : (
				<Box>
					{renderImageViewer()}

					<StatisticsFilters
						users={users}
						userFilter={userFilter}
						orderFilter={orderFilter}
						timePick={timePick}
						shift={shift}
						onUserChange={handleChangeUser}
						onOrderChange={handleChangeOrder}
						onTimeChange={setTime}
						onShiftChange={setShift}
					/>

					<Card>{statistics?.detail?.length === 0 ? renderNoData() : renderOrderList()}</Card>

					<StatisticUpdateHistoryModal
						open={!!updateHistory}
						onClose={() => setUpdateHistory(null)}
						updateHistory={updateHistory}
					/>
				</Box>
			)}
		</UserLayout>
	)
}

const styles = {
	loadingContainer: {
		marginTop: '120px',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
	backdrop: (mediaMd) => ({
		color: '#fff',
		zIndex: 999,
		left: mediaMd ? 300 : 0,
	}),
	viewerImage: {
		maxHeight: '70%',
		maxWidth: '90%',
	},
	noDataContainer: {
		backgroundColor: '#fff',
		padding: '10px',
		borderRadius: '10px',
		margin: '10px auto',
		width: '992px',
	},
	orderListContainer: (mediaMd) => ({
		padding: '0 16px',
		margin: '0 auto',
		position: 'fixed',
		top: mediaMd ? 220 : 210,
		left: mediaMd ? 300 : 0,
		right: 0,
		bottom: 0,
		overflow: 'auto',
		// '@media (max-width: 768px)': {
		// 	padding: '0 8px',
		// },
	}),
}
